// extracted by mini-css-extract-plugin
export var colorBox1 = "boxContainer-module--colorBox1--YR803";
export var colorBox2 = "boxContainer-module--colorBox2--TVJMa";
export var colorBox3 = "boxContainer-module--colorBox3--fMj-K";
export var colorBox4 = "boxContainer-module--colorBox4--HciYZ";